import React, { useState, Dispatch, SetStateAction } from "react";
import { AvailableLanguages, T } from "services/lang/LanguageService";
import { Dashboard } from "api/model/dashboard/Dashboard";
import { Input } from "../InputCategories";

const availableLanguagesOptions = Object.values(AvailableLanguages).map(lang => ({
  label: lang.toLocaleUpperCase(),
  value: lang,
}));

const GeneralSubForm = (props: {
  dashboard: Dashboard;
  setNewGeneralSub: Dispatch<SetStateAction<object>>;
}) => {
  const [title, setTitle] = useState<string>(props.dashboard.title);
  const [companyShared, setCompanyShared] = useState<boolean>(props.dashboard.companyShared);
  const [language, setLanguage] = useState(props.dashboard.reportOptions?.language ?? "");
  const onGeneralInputChange = (key: keyof Dashboard, value: any) => {
    if (key === "title") {
      setTitle(value);
    } else if (key === "companyShared") {
      setCompanyShared(value);
    }
    props.setNewGeneralSub(prevState => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleLanguageChange = (val: string) => {
    setLanguage(val);
    props.setNewGeneralSub(prev => ({
      ...prev,
      reportOptions: {
        ...((prev as Dashboard).reportOptions ?? props.dashboard.reportOptions ?? {}),
        language: val,
      },
    }));
  };

  const handleForceCompanyTzChange = (value: boolean) => {
    props.setNewGeneralSub(prev => ({
      ...prev,
      reportOptions: {
        ...((prev as Dashboard).reportOptions ?? props.dashboard.reportOptions ?? {}),
        forceCompanyTz: value,
      },
    }));
  };

  return (
    <>
      <h5 className="mb-5">{T("word.general")}</h5>
      <div className="grid">
        <span className="p-float-label col-12 md:col-3">
          <Input.Text
            id="input-dashboard-title"
            label={T("word.title")}
            property="title"
            sourceObj={{ title }}
            onChange={onGeneralInputChange}
          />
        </span>

        <span className="p-float-label col-12 md:col-2">
          <Input.Text
            id="input-dashboard-icon-class"
            label={T("word.icon-class")}
            property="iconClass"
            sourceObj={props.dashboard}
            onChange={onGeneralInputChange}
            editable
          />
        </span>

        <span className="p-float-label col-12 md:col-2">
          <Input.List
            id="input-dashboard-report-options-language"
            label={T("word.language")}
            options={availableLanguagesOptions}
            property="language"
            sourceObj={{ language }}
            onChange={(key, value) => handleLanguageChange(value)}
          />
        </span>

        <span className="col-12 md:col-5 flex align-items-center gap-3">
          <Input.Boolean
            id="input-dashboard-use-shared"
            label={T("word.company-shared")}
            property="companyShared"
            sourceObj={{ companyShared }}
            onChange={onGeneralInputChange}
          />
          {/* TODO : add forceCompanyTz */}
          {/* <Input.Boolean
            id="input-dashboard-use-company-tz"
            label={T("action.use-company-tz")}
            property="forceCompanyTz"
            sourceObj={{ useCompanyTimezone: props.dashboard.reportOptions?.forceCompanyTz ?? false }}
            onChange={(key, value) => handleForceCompanyTzChange(value)}
          /> */}
        </span>
      </div>
    </>
  );
};

export default GeneralSubForm;
